import { InfoPanelTypeComponent } from './info-panel-type.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import {
  AvatarModule,
  MatTooltipAddonsDirective,
} from '@lockton-apps/shared/ui/lui';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '@lockton-apps/material';

@NgModule({
  declarations: [InfoPanelTypeComponent],
  imports: [
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'info-panel',
          component: InfoPanelTypeComponent,
        },
      ],
    }),
    AvatarModule,
    MatIconModule,
    MaterialModule,
    MatTooltipAddonsDirective,
  ],
})
export class InfoPanelTypeModule {}
